import { gql } from "@apollo/client";

export const CREATE_PAYPAL_TOKEN_GQL = gql`
  mutation CreatePaypalExpressToken(
    $cartId: String!
    $returnUrl: String!
    $cancelUrl: String!
  ) {
    createPaypalExpressToken(
      input: {
        cart_id: $cartId
        code: "paypal_express"
        urls: { return_url: $returnUrl, cancel_url: $cancelUrl }
        is_external_frontend: true
      }
    ) {
      token
      paypal_urls {
        start
        edit
      }
    }
  }
`;

export const QUERY_GET_PAYPAL_LIB_URL_GQL = gql`
  query storeConfig {
    storeConfig {
      paypal_lib_url
    }
  }
`;
export const SET_PAYPAL_PAYMENT_METHOD_GQL = gql`
  mutation SetPaymentMethodOnCart(
    $cartId: String!
    $payerId: String!
    $token: String!
  ) {
    setPaymentMethodOnCart(
      input: {
        cart_id: $cartId
        payment_method: {
          code: "paypal_express"
          paypal_express: { payer_id: $payerId, token: $token }
        }
      }
    ) {
      cart {
        selected_payment_method {
          code
          title
        }
      }
    }
  }
`;
